const SESSION_DURATION = 2 * 60 * 60 * 1000;  
 

export const getCurrentTime = () => new Date().getTime();


export const checkSessionExpiry = () => {
  const loginTime = localStorage.getItem("loginTime");
  if (loginTime) {
    const currentTime = getCurrentTime();
    const timeElapsed = currentTime - parseInt(loginTime, 10);
    
    if (timeElapsed > SESSION_DURATION) {
      // Session expired
      alert("Your session has expired. Please log in again!");
      clearSession();
    }
  }
};

export const clearSession = () => {
  localStorage.removeItem("admin");
  localStorage.removeItem("token");
  localStorage.removeItem("twk_idm_key");
  localStorage.removeItem("twk_uuid_6583dce370c9f2407f8220c3");
  localStorage.removeItem("tokenuser");
  localStorage.removeItem("favourite");
  localStorage.removeItem("useraddress");
  localStorage.removeItem("loginTime");
  location.reload(); // Reload the page to redirect to login or home
  window.dispatchEvent(new Event("authChange"));
};

export const updateActivityTime = () => {
  localStorage.setItem("loginTime", getCurrentTime().toString());
};
